module.exports = __webpack_public_path__ + "img/safesurgery.7ae2257e.png";